import { IsNumber } from 'class-validator';

export class PosValidateStaffIdRequestDto {
  @IsNumber()
  public posStaffId: number;

  @IsNumber()
  public posDeviceId: number;

  constructor(posAccessId: number, posDeviceId: number) {
    this.posStaffId = posAccessId;
    this.posDeviceId = posDeviceId;
  }
}
